import { Col, Form, Input, Row, Select } from "antd";
import _ from "lodash";
import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { compose } from "redux";
import {
  GUTTER_MD, MARGIN_MD, SPAN_HALF
} from "../../../../../../../styles/constants";
import { freeTextValue } from "../../../utils";

const mapPropsToFields = ({value}) => ({
  name: Form.createFormField({value: value !== null ? value.name : null}),
  text: Form.createFormField({value: value !== null ? value.text : null}),
});

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const ConcatenatedValue = ({ 
  t,
  value,
  form,
  components,
}) => {

  const freeTextTitle = t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.freeTextValue.title');
  const placeholder=t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.freeTextValue.placeholder');

  return (
    <Fragment>
      {value.idx > 0 && (
      <Row gutter={GUTTER_MD}  style={{marginBottom: MARGIN_MD}}> 
        <Col>
          <span
            style={{fontWeight:"bold"}}
          >
            {t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.cubeComponentList.valueDefinitionForm.concat.title')} 
          </span>
        </Col>
      </Row>
      )}
      <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
        <Col span={SPAN_HALF}>
        {form.getFieldDecorator("name")(
          <Select
            style={{width:"100%"}}
            showSearch
            filterOption={(inputValue, {props}) =>
                props.title.toLowerCase().includes(inputValue.toLowerCase())
            }
          >
            {components.map((option, index) => (
              <Select.Option
                key={index}
                value={option.name}
                title={option.name === freeTextValue 
                  ? freeTextTitle 
                  : option.name}
              >
                {option.name === freeTextValue 
                  ? freeTextTitle 
                  : option.name}
              </Select.Option>
            ))}
          </Select>
          )}
        </Col>
        {value.name === freeTextValue && (
          <Col span={SPAN_HALF}>
            {form.getFieldDecorator("text")(
            <Input
              placeholder={placeholder}
            />)}
          </Col>
          
        )}        
      </Row>      
    </Fragment>
  );
};

export default compose(
  translate(),
  Form.create({mapPropsToFields, onFieldsChange})
)(ConcatenatedValue);

